import { createFileRoute } from '@tanstack/react-router';
import { DepartmentDetailPage } from '@/pages/organization/departments/DepartmentDetailPage';
import { createEntityBreadcrumbLoader } from '@/lib/entity-breadcrumb';

export const Route = createFileRoute('/$slug/organization/departments/$departmentId')({
  loader: createEntityBreadcrumbLoader('department', 'departmentId'),
  component: RouteComponent
});

function RouteComponent() {
  const { departmentId } = Route.useParams();
  return <DepartmentDetailPage departmentId={departmentId} />;
}
